// extracted by mini-css-extract-plugin
export default {"select":"TableSelector_select__45la+"};